import {getCurrentLang} from "../helpers/helper";

export default class CartIcon {
    itemCount = 0;
    shopCode = null;
    isPopupOpen = false;

    constructor() {
        if (document.querySelector('.cart-icon')) {
            this.setupPopup();
            this.loadCartData();
            this.initCarts();
        }
    }

    syncPopupDisplay() {
        const popupContainer = document.querySelector('#cart-popup');
        if (this.isPopupOpen) {
            popupContainer.classList.add('is-open');
        } else {
            popupContainer.classList.remove('is-open');
        }
    }

    setupPopup() {
        const firstCart = document.querySelector('.cart-icon');
        const popup = document.createElement('div');

        popup.id = 'cart-popup';
        popup.innerHTML = '<div class="card">' + window.jsTranslations['no_cart_open'] + '</div>';
        firstCart.append(popup);

        document.addEventListener('click', (e) => {
            const popupContainer = document.querySelector('#cart-popup');
            if (!popupContainer.contains(e.target) && !popup.contains(e.target)) {
                this.isPopupOpen = false;
                this.syncPopupDisplay();
            }
        })
    }

    loadCartData() {
        const cartContent = JSON.parse(sessionStorage.getItem('ike_cart_content'));
        this.itemCount = cartContent?.item_count || 0;
        this.shopCode = cartContent?.last_shop_code || null;
    }

    initCarts() {
        const carts = document.querySelectorAll('.cart-icon');
        for (const cart of carts) {
            this.initCart(cart);
        }
    }

    initCart(cart) {
        if (this.itemCount > 0) {
            const countContainer = cart.querySelector('.button-pill');
            countContainer.innerHTML = this.itemCount;
            cart.href = `/${getCurrentLang()}/shop/${this.shopCode}/order`;
            return;
        }

        // Toggle "Aucun panier ouvert" popup display
        cart.addEventListener('click', (e) => {
            e.stopPropagation();

            const popupContainer = document.querySelector('#cart-popup');

            if (popupContainer.contains(e.target)) {
                return;
            }

            this.isPopupOpen = !this.isPopupOpen;
            this.syncPopupDisplay();
        });
    }
}
